import styles from "../styles.module.scss";
import localStyles from "./styles.module.scss";
import {ProductType, useAppData} from "../../context/Contexts";
import {useEffect, useMemo, useRef, useState} from "react";
import {
    formatMoney,
    formatShopifyMoney,
    getCompareOfferPrice,
    getCurrency,
    getExcludedAddonSkus,
    getOfferPrice,
    isBundle,
    isFront,
    isRear,
    isCustomFront,
    getPriceElemById, getNewPartNumber,
    getVariantMetafields,
    isCustomRearAvailable,
    getCustomRearOptions,
    getComponentSkus,
    getSeatCoverId,
    syncPaymentTermsVariantId,
} from "../../helpers/helpers";
import StatusBar from "../StatusBar";
import Step1 from "../Step1";
import MainStep from "../MainStep";
import StepNoCompatible from "../StepNoCompatible";
import {set} from "react-hook-form";
import { sessionService } from "../../services/SessionService";
//import { useWhatChanged } from '@simbathesailor/use-what-changed';
import { getDraftCartStore, type DraftCartItem } from '../../features/draftOrder/DraftCartStore';
import { DraftCartDrawer } from '../../features/draftOrder/DraftCartDrawer';
import { calculateShipByDate, DEFAULT_SHIP_BY_DAYS, getMaxShipByDate } from '../../utils/shippingDate';
import { fetchHolidays, useHolidaysQuery } from '../../services/HolidaysService';
import { getActivePromoCode, fetchGiftSetVariants, fetchGiftSetBundleDisplay, numericVariantId, type BundleDisplay } from '../../services/GiftSetService';
import GiftBundleStrip from '../GiftBundleStrip';

declare global {
    interface Window {
        is_real_truck?: boolean;
        scs_custom_endpoint?: boolean;
        scs_custom_endpoint_url?: string;
        scs_show_new_year_promo_section?: boolean;
        scs_show_str_section?: boolean;
        scs_show_bf_section?: boolean;
        scs_show_earlybf_section?: boolean;
        scs_bonus_discount?: string;
        scs_bonus_product?: string;
        scs_custom_style?: string;
        scs_extra_media?: object;
        scs_use_alternate_images?: boolean;
        is_embedded?: boolean;
        scs_step_1_bottom_text?: string;
        scs_step_2_bottom_text?: string;
        scs_widget_id?: string;
        scs_use_optgroup?: boolean;
        scs_force_custom?: boolean;
        scs_force_normal?: boolean;
        scs_page_seo?: boolean;
        scs_show_bonus_section?: boolean;
        scs_show_timer?: boolean;
        scs_countdown_timer?: string;
        scs_use_custom_title?: boolean;
        scs_show_color_alert?: boolean;
        scs_product_alert_text?: string;
        scs_alert_colors?: string[];
        scs_bulk_alert_colors?: string[];
        scs_has_double_offer?: boolean;
        scs_blocks?: string[];
        Shopify?: any;
        scs_ultimate_upgrade?: boolean;
        scs_hide_timer?: boolean;
        scs_hide_bonus_3_section?: boolean;
        scs_black_friday_2025?: boolean;
        scs_black_friday_2025_h1?: string;
        scs_black_friday_2025_h2?: string;
        scs_title_show_timer?:boolean;

        scs_promo_bonus_sale_price_1?:string;
        scs_promo_bonus_sale_price_2?:string;
        scs_promo_bonus_sale_price_3?:string;
        scs_promo_bonus_compare_price_1?:string;
        scs_promo_bonus_compare_price_2?:string;
        scs_promo_bonus_compare_price_3?:string;

        scs_promo_bonus_1_price?:number;
        scs_promo_bonus_1_alt?:string;
        scs_promo_bonus_1_img?:string;
        scs_promo_bonus_1_title?:string;

        scs_promo_bonus_2_price?:number;
        scs_promo_bonus_2_alt?:string;
        scs_promo_bonus_2_img?:string;
        scs_promo_bonus_2_title?:string;

        scs_promo_bonus_3_price?:number;
        scs_promo_bonus_3_alt?:string;
        scs_promo_bonus_3_img?:string;
        scs_promo_bonus_3_title?:string;

        scs_promo_bonus_4_price?:number;
        scs_promo_bonus_4_alt?:string;
        scs_promo_bonus_4_img?:string;
        scs_promo_bonus_4_title?:string;

        scs_promo_extra_images_filter?:string;
        scs_promo_special_text?:string;
        scs_special_price_title?:string;
        scs_new_design_2026?:boolean;
        scs_offer_preorder?:boolean;

        scs_fast_shipping_text?:string;
        scs_show_addons?: boolean;

        scs_biz2_flow?: boolean;
        scs_biz2?: boolean;
        scs_custom_rear_seats?: boolean;
        scs_vehicle_configurator?: boolean;
        scs_ignore_parent_list?: string;
        scs_upsells_sale_prices?: string;
        scs_upsells_widget_ids?: string;

    }
}

const PET_COVER_DRAWER_HANDLE = 'petsuite-hard-bottom-dog-seat-protector-no-fur';

function selectPetCoverVariantInCartDrawer(vehicleType: string | undefined) {
    const isTruck = vehicleType === 'Truck';

    const applySelection = (): boolean => {
        const card = document.querySelector(`[data-product-handle="${PET_COVER_DRAWER_HANDLE}"]`);
        if (!card) return false;
        const radios = card.querySelectorAll<HTMLInputElement>(
            '.ACC_SCS_Cartdrawer_32_review_product_variant_option input[type="radio"]'
        );
        if (!radios.length) return false;
        for (const radio of radios) {
            const nameEl = radio
                .closest('.ACC_SCS_Cartdrawer_32_review_product_variant_option')
                ?.querySelector('.ACC_SCS_Cartdrawer_32_review_product_variant_name');
            const name = nameEl?.textContent?.trim().toLowerCase() ?? '';
            const isMatch = isTruck ? name.includes('truck') : (name.includes('car') || name.includes('suv'));
            if (isMatch && !radio.checked) {
                radio.click();
            }
        }
        return true;
    };

    if (applySelection()) return;

    const observer = new MutationObserver(() => {
        if (applySelection()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
}

function shouldIgnoreParent(id: string | number | undefined | null): boolean {
    if (id === undefined || id === null) return false;
    const raw = (typeof window !== 'undefined' && window.scs_ignore_parent_list) || '';
    if (!raw) return false;
    const target = String(id);
    return raw.split(',').some((entry) => entry.trim() === target);
}

interface CustomScsParams {
    _scs_utm_medium?: string;
    _scs_utm_campaign?: string;
    _scs_utm_source?: string;
    _scs_attribution?: string;
    _trim?: string;
    _cab_size?: string;
    _url?: string;
    _gid?: string;
    Trim?: string;
    _date_add_to_cart?: string;
    _ships_by?: string;
}

interface ScsProperties {
    _source?: string;
    _seat?: string;
    _color?: string;
    _bonus?: string;
    _bonus_type?: string;
    _widget_id?: string;
    _your_vehicle?: string;
    "Your Vehicle"?: string;
    Trim?: string;
    _trim?: string;
    _cab_size?: string;
    _gid?: string;
    _session_id?: string;
    _addon_sku?: string;
    _vehicle_type?: string;
    [key: string]: any;
}

async function getCustomSku(
    input: {
        step?: number | undefined;
        seat?: string | undefined;
        color?: string | undefined;
        selectedId?: string | undefined;
        year?: number | undefined;
        make?: string | undefined;
        model?: string | undefined;
        sku_mapping_availability?: Record<string, any> | null | undefined;
        check?:
            | {
            compatibility: string;
            compatibility_custom: string;
            availability: object;
        }
            | undefined;
        product?: ProductType | undefined;
        originalProduct?: ProductType | undefined;
        addons?: string | undefined;
        trim?: string | undefined;
        has_trims?: boolean | undefined;
        with_bonus?: boolean | undefined;
    },
    sku,
) {
    // When a VehicleConfigurator mapping has been resolved (e.g. F-150 rear seat questions),
    // sku_mapping_availability holds the question-answer-specific availability. Use getNewSku()
    // which reads from that mapping — api/v1/sku has no knowledge of question answers and would
    // return the wrong or a generic part number for configurator vehicles.
    if (input.sku_mapping_availability) {
        const resolved = getNewSku(input);
        if (resolved) return resolved;
    }

    const requestOptions: RequestInit = {
        method: "GET",
        redirect: "follow",
    };

    const resp = await fetch(
        withPartNumberSkuQuery(
            `https://scsbiz.wearevisum.com/api/v1/sku?` +
            `year=${encodeURIComponent(input.year ?? "")}` +
            `&make=${encodeURIComponent(input.make ?? "")}` +
            `&model=${encodeURIComponent(input.model ?? "")}` +
            `&type=${encodeURIComponent(input.seat ?? "")}` +
            `&color=${encodeURIComponent(input.color ?? "")}`,
        ),
        requestOptions,
    );

    const data = await resp.json();
    return data.data;
}

function getConfiguredAnswers() {
    const params = new URLSearchParams(window.location.search);
    const questionsParam = params.get("questions");
    const answersParam = params.get("answers");

    if (!questionsParam && !answersParam) {
        return "";
    }

    const questionIds = questionsParam ? questionsParam.split(",").map((id) => id.trim()).filter(Boolean) : [];
    const answerKeys = answersParam ? answersParam.split(",").map((answer) => answer.trim()).filter(Boolean) : [];

    if (questionIds.length === 0 && answerKeys.length === 0) {
        return "";
    }

    if (questionIds.length > 0 && answerKeys.length > 0) {
        const mapped = questionIds.map((questionId, index) => {
            const answer = answerKeys[index] ?? "";
            return answer ? `${questionId}=${answer}` : "";
        }).filter(Boolean);

        if (mapped.length > 0) {
            return mapped.join(";");
        }
    }

    if (answerKeys.length > 0) {
        return answerKeys.map((answer, index) => `Q${index + 1}=${answer}`).join(";");
    }

    return "";
}

import { resolveAvailabilitySeatKey, withPartNumberSkuQuery, getJumpSeatCoverId } from '../../helpers/helpers';

function getNewSku(currentAppData) {
    if (!currentAppData?.seat || !currentAppData?.color) {
        return "";
    }

    const seatKey = resolveAvailabilitySeatKey(currentAppData.seat, currentAppData.sku_mapping_availability);
    const skuMapNew = currentAppData.sku_mapping_availability?.[seatKey]?.["new_sku"]?.[currentAppData.color];
    if (skuMapNew !== undefined && skuMapNew !== null) {
        return skuMapNew;
    }

    const frontSeatsNewSku = currentAppData.sku_mapping_availability?.["Front Seats"]?.["new_sku"];
    if (typeof frontSeatsNewSku === 'string' && frontSeatsNewSku) {
        return frontSeatsNewSku;
    }

    const seatKeyForCheck = resolveAvailabilitySeatKey(currentAppData.seat, currentAppData?.check?.availability ?? undefined);
    if (currentAppData?.check?.availability?.[seatKeyForCheck]?.["new_sku"]?.[currentAppData.color]) {
        return currentAppData.check.availability[seatKeyForCheck]["new_sku"][currentAppData.color];
    }

    return "";
}

export default function StepNav(props) {
    const {currentAppData, setCurrentAppData} = useAppData();

    const [disabled, setDisabled] = useState(true);
    const attentionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const autoHighlightModelRef = useRef<string | null>(null);

    // When Next is pressed while disabled (the click falls through to the section,
    // see button:disabled in styles), pulse a red glow on the first empty required
    // dropdown (Year/Make/Model/Trim/Cab) or unanswered configurator question
    // so the user knows where to click next.
    function handleDisabledNavClick() {
        if (!disabled || loading) {
            return;
        }
        const selects = Array.from(document.querySelectorAll<HTMLSelectElement>(
            'select[name="vehicle-year"], select[name="vehicle-make"], select[name="vehicle-model"], select#vehicle-trim, select#vehicle-cab-size'
        ));
        const target = selects.find((el) => !el.value && !el.disabled && el.offsetParent !== null)
            ?? Array.from(document.querySelectorAll<HTMLElement>('[data-scs-question-pending]'))
                .find((el) => el.offsetParent !== null);
        if (!target) {
            return;
        }
        if (attentionTimeoutRef.current) {
            clearTimeout(attentionTimeoutRef.current);
        }
        // Re-trigger the animation when the class is already applied
        target.classList.remove(styles.field_attention);
        target.getBoundingClientRect(); // force reflow so the animation restarts
        target.classList.add(styles.field_attention);
        target.scrollIntoView({behavior: 'smooth', block: 'center'});
        attentionTimeoutRef.current = setTimeout(() => {
            target.classList.remove(styles.field_attention);
        }, 3400);
    }

    // Auto-highlight trim when it first appears for a given model.
    useEffect(() => {
        if (!currentAppData?.has_trims) {
            autoHighlightModelRef.current = null;
            return;
        }
        if (currentAppData?.trim) return;
        const model = currentAppData?.model;
        if (!model || autoHighlightModelRef.current === model) return;

        const tid = setTimeout(() => {
            const trimEl = document.querySelector<HTMLSelectElement>('select#vehicle-trim');
            if (!trimEl || trimEl.offsetParent === null) return;
            autoHighlightModelRef.current = model;
            trimEl.classList.add(styles.field_attention_persist);
            trimEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
        return () => clearTimeout(tid);
    }, [currentAppData?.has_trims, currentAppData?.model]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (currentAppData?.trim) {
            document.querySelector<HTMLSelectElement>('select#vehicle-trim')
                ?.classList.remove(styles.field_attention_persist);
        }
    }, [currentAppData?.trim]);

    const [product, setProduct] = useState({});

    const [loading, setLoading] = useState(false);

    const [options, setOptions] = useState([]);
    const [price, setPrice] = useState("");
    const [priceRawAmount, setPriceRawAmount] = useState(0);
    const [comparePrice, setComparePrice] = useState("");
    const [savings, setSavings] = useState<undefined | string>(undefined);
    const [partNumber, setPartNumber] = useState('');
    const [variantMetafields, setVariantMetafields] = useState<{preorder_enabled?: string, preorder_ship_date?: string} | null>(null);
    const [isPreOrderClick, setIsPreOrderClick] = useState(false);

    // Compute ship-by date from the SKU's shipping range in window.scs_off_site_skus_full.
    // Bundle/Set selections are made of multiple component SKUs (e.g. front seat +
    // rear bench), so we take the worst-case (furthest-out) date across partNumber
    // and all of its components, not just partNumber alone.
    const holidaysQuery = useHolidaysQuery();

    const shipByDate = useMemo(() => {
        const componentSkus = getComponentSkus(currentAppData);
        const holidays = holidaysQuery.data ?? [];
        const result = getMaxShipByDate([partNumber, ...componentSkus], undefined, holidays);
        if (result) return result;
        return window.scs_ship_by_date_format2 ? calculateShipByDate(String(DEFAULT_SHIP_BY_DAYS), undefined, holidays) : null;
    }, [partNumber, currentAppData?.seat, currentAppData?.color, currentAppData?.check, currentAppData?.sku_mapping_availability, holidaysQuery.data]);
    const [draftCartItems, setDraftCartItems] = useState<DraftCartItem[]>([]);
    const [draftCartAttributes, setDraftCartAttributes] = useState<Record<string, string>>({});
    const [draftCartOpen, setDraftCartOpen] = useState(false);
    const [giftBundleDisplay, setGiftBundleDisplay] = useState<BundleDisplay | null>(null);

    useEffect(() => {
        const promoCode = getActivePromoCode();
        if (!promoCode) return;
        let cancelled = false;
        fetchGiftSetBundleDisplay(promoCode).then((data) => {
            if (!cancelled) setGiftBundleDisplay(data);
        });
        return () => { cancelled = true; };
    }, []);

    function getGid() {
        const id = window.crypto.randomUUID();
        return id;
    }

    function getSeatId() {
        const colorSelected = currentAppData?.color;
        if (colorSelected === undefined) {
            return "46996385366308";
        }
        const colorMapping = {
            Black: "46996385366308",
            "Black & Grey": "47575557144868",
            Beige: "46996385333540",
            "Wine Red": "49936887021860",
            "Black & Red": "49936887120164",
            "Black & Blue": "49936887087396",
            "Black & White": "49936887054628",
            "Black & Pink": "46996385366308",
            Tan: "46996385366308",
        };

        if (!colorMapping.hasOwnProperty(colorSelected)) {
            return "46996385366308";
        }

        return colorMapping[colorSelected];
    }

    useEffect(() => {
        const product1 = currentAppData?.product;
        if (product1 && product1.options) {
            setProduct(product1);
        }
    }, [currentAppData?.product]);

    useEffect(() => {
        if (!window.scs_new_design_2026) {
            return;
        }
        // Only auto-advance in the new design when the UI is enabled (disabled === false)
        // AND we have a compatibility check confirming there are available options for this vehicle.
        // This avoids advancing based solely on presence of URL params / storage values.
        if (disabled === false && currentAppData?.year && currentAppData?.make && currentAppData?.model && currentAppData?.check) {
            // Verify availability: any seat/color flagged as available
            const availabilityObj = currentAppData?.check?.availability;
            const availabilityOk = availabilityObj && Object.values(availabilityObj).some(seatObj => {
                try {
                    return Object.values((seatObj as any)).some(v => v === true || v === 'true');
                } catch (e) {
                    return false;
                }
            });

            // Only auto-advance if availability exists, biz2 availability check is done,
            // and no required vehicle options are missing
            if (
                availabilityOk &&
                !currentAppData?.biz2_availability_loading &&
                !(
                    (currentAppData?.has_trims && (!currentAppData?.trim || currentAppData?.trim === "")) ||
                    (currentAppData?.has_cabs && (!currentAppData?.cab || currentAppData?.cab === ""))
                )
            ){
                const tid = setTimeout(() => {
                    setCurrentAppData(prevState => {
                        // Don't override if something already advanced the step beyond 1
                        // (e.g. the availability effect in Step1New advanced to step 2 for configurator flow)
                        if (prevState.step !== 1) return prevState;
                        // In biz2 new design, advance to seat-type step (2) first; color (3) follows after seat selection.
                        return {...prevState, step: window.scs_biz2 ? 2 : 3};
                    });
                }, 100);
                return () => clearTimeout(tid);
            }
        }
    }, [disabled, currentAppData?.biz2_availability_loading]);

    useEffect(() => {
        if (disabled === false) {
            // In the biz2+vehicle_configurator flow, VehicleConfigurator owns configurator_complete
            // for steps 2 (seat selection) and 3 (questions). Setting it true here at those steps
            // would bypass the question flow. VehicleConfigurator advances those steps itself.
            const isVehicleConfiguratorFlow = window.scs_vehicle_configurator && window.scs_biz2;
            const step = currentAppData?.step ?? 0;
            if (isVehicleConfiguratorFlow && step <= 3) {
                window.dispatchEvent(new CustomEvent('ConfiguratorCompleted', {
                    detail: {
                        year: currentAppData?.year,
                        make: currentAppData?.make,
                        model: currentAppData?.model,
                        trim: currentAppData?.trim,
                        seat: currentAppData?.seat,
                        color: currentAppData?.color,
                        selectedId: currentAppData?.selectedId,
                        configurator_complete: true,
                    }
                }));
                return;
            }
            setCurrentAppData(prevState => ({ ...prevState, configurator_complete: true }));
            window.dispatchEvent(new CustomEvent('ConfiguratorCompleted', {
                detail: {
                    year: currentAppData?.year,
                    make: currentAppData?.make,
                    model: currentAppData?.model,
                    trim: currentAppData?.trim,
                    seat: currentAppData?.seat,
                    color: currentAppData?.color,
                    selectedId: currentAppData?.selectedId,
                    configurator_complete: true,
                }
            }));
        }
    }, [disabled]);

    useEffect(() => {
        const filtered = getPriceElemById(product.variants, currentAppData?.selectedId, currentAppData);

        // Sum prices of checked custom rear addons
        let rearAddonsPrice = 0;
        let rearAddonsComparePrice = 0;
        const rearAddons = currentAppData?.customRearAddons || [];
        const rearProduct = currentAppData?.customRearProduct;
        if (rearAddons.length > 0 && rearProduct?.variants) {
            const selectedColor = currentAppData?.color;
            rearAddons.forEach((addonKey) => {
                const seatName = addonKey === 'rear_seat' ? 'Custom 2nd Row'
                    : addonKey === '2nd_row' ? 'Custom 2nd Row'
                    : 'Custom 3rd Row';
                const matchingVariant = rearProduct.variants.edges?.find((v: any) =>
                    v.node.selectedOptions.some((o: any) => o.name === 'Seats' && o.value === seatName) &&
                    (!selectedColor || v.node.selectedOptions.some((o: any) => o.name === 'Color' && o.value === selectedColor))
                ) || rearProduct.variants.edges?.find((v: any) =>
                    v.node.selectedOptions.some((o: any) => o.name === 'Seats' && o.value === seatName)
                );
                if (matchingVariant) {
                    const addonPrice = parseFloat(matchingVariant.node.priceV2.amount);
                    rearAddonsPrice += addonPrice;
                    const addonCompare = getCompareOfferPrice(
                        addonPrice,
                        matchingVariant.node.compareAtPrice ? parseFloat(matchingVariant.node.compareAtPrice.amount) : undefined,
                    );
                    rearAddonsComparePrice += addonCompare !== undefined ? addonCompare : addonPrice;
                }
            });
        }

        const hasFrontSeat = !!currentAppData?.seat;
        if (filtered.length > 0 && hasFrontSeat) {
            const rawPrice = parseFloat(filtered[0].node.priceV2.amount) + rearAddonsPrice;
            setPriceRawAmount(rawPrice);
            setPrice(formatShopifyMoney(getOfferPrice(rawPrice)));

            const hasCompare = !!filtered[0].node.compareAtPrice || rearAddonsComparePrice > 0;
            if (hasCompare) {
                const frontPrice = parseFloat(filtered[0].node.priceV2.amount);
                const computedCompare = getCompareOfferPrice(
                    frontPrice,
                    filtered[0].node.compareAtPrice ? parseFloat(filtered[0].node.compareAtPrice.amount) : undefined,
                );
                const baseCompare = computedCompare !== undefined ? computedCompare : frontPrice;
                const rawCompare = baseCompare + rearAddonsComparePrice;
                setComparePrice(formatShopifyMoney(rawCompare));
                setSavings(
                    formatShopifyMoney(
                        rawCompare - getOfferPrice(rawPrice),
                    ),
                );
            } else {
                setComparePrice("");
                if (window.scs_show_earlybf_section) {
                    setSavings(formatShopifyMoney(20));
                } else {
                    setSavings(undefined);
                }
            }
        } else if (rearAddons.length > 0 && rearAddonsPrice > 0) {
            // Front seat skipped, only rear addons
            setPriceRawAmount(rearAddonsPrice);
            setPrice(formatShopifyMoney(rearAddonsPrice));
            if (rearAddonsComparePrice > rearAddonsPrice) {
                setComparePrice(formatShopifyMoney(rearAddonsComparePrice));
                setSavings(formatShopifyMoney(rearAddonsComparePrice - rearAddonsPrice));
            } else {
                setComparePrice("");
                setSavings(undefined);
            }
        } else {
            setSavings(undefined);
        }

    }, [currentAppData?.selectedId, currentAppData?.seat, currentAppData?.customRearAddons, currentAppData?.customRearProduct, currentAppData?.check, currentAppData?.sku_mapping_availability]);

    useEffect(() => {
        const newSku = getNewSku(currentAppData);
        setPartNumber(newSku || getNewPartNumber(currentAppData));
    }, [currentAppData?.check, currentAppData?.selectedId, currentAppData?.seat, currentAppData?.color, currentAppData?.sku_mapping_availability, currentAppData?.step])

    useEffect(() => {
        if (currentAppData?.product?.variants && currentAppData?.selectedId) {
            const metafields = getVariantMetafields(currentAppData.product.variants, currentAppData.selectedId);
            setVariantMetafields(metafields);
        } else {
            setVariantMetafields(null);
        }
    }, [currentAppData?.selectedId, currentAppData?.product]);

    // Single source of truth for keeping the theme's #payment_terms form's variant id
    // in sync with whatever add-to-cart would actually submit (see getSeatCoverId).
    useEffect(() => {
        syncPaymentTermsVariantId(getSeatCoverId(currentAppData));
    }, [
        currentAppData?.selectedId,
        currentAppData?.seat,
        currentAppData?.color,
        currentAppData?.biz2_coverages,
        currentAppData?.sku_mapping_availability,
        currentAppData?.check,
    ]);

    // const handleBack = () => {
    //     setCurrentAppData(prevState => {
    //         return {...prevState, step: prevState.step - 1}
    //     });
    function setDoubleOffer() {
        if (window.scs_has_double_offer !== true) {
            return;
        }
        if (currentAppData?.show_upsell !== true) {
            setCurrentAppData(prevState => {
                return {...prevState, show_upsell: true, show_offer: false}
            })

        } else {

            setCurrentAppData((prevState) => {
                return {
                    ...prevState,
                    show_upsell: false,
                    show_offer: false,
                    year: '',
                    make: '',
                    model: '',
                    step: 1
                };
            });
        }
    }

    // }
    const handleNext = async (preOrderClick: boolean = false) => {
        let element1;
        if (currentAppData?.step === 3 || (window.scs_new_design_2026 && !window.scs_biz2 && currentAppData?.step === 2) || (window.scs_new_design_2026 && window.scs_biz2 && currentAppData?.step === 4)) {
            setLoading(true);
            sessionService.trackAction('add_to_cart_clicked', {
                year: currentAppData?.year,
                make: currentAppData?.make,
                model: currentAppData?.model,
                trim: currentAppData?.trim,
                cab: currentAppData?.cab,
                seat: currentAppData?.seat,
                color: currentAppData?.color,
                selected_variant_id: currentAppData?.selectedId,
                preorder: preOrderClick,
            });
            if (
                window.is_real_truck === true ||
                window.scs_custom_endpoint === true
            ) {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                const filteredVariants = currentAppData.product?.variants?.edges.filter(
                    (variant) => {
                        return (
                            variant.node.id.replace("gid://shopify/ProductVariant/", "") ==
                            currentAppData?.selectedId
                        );
                    },
                );

                if (!filteredVariants || filteredVariants.length == 0) {
                    alert("No matches");
                    return;
                }
                const selectedVariant = filteredVariants[0];
                const configuration = getConfiguredAnswers();

                const raw = JSON.stringify([
                    {
                        sku: await getCustomSku(currentAppData, selectedVariant.node.sku),
                        name:
                            currentAppData?.product?.title +
                            " - " +
                            selectedVariant.node.title,
                        fitment: `${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model}`,
                        ...(configuration ? { configuration } : {}),
                        qty: "1",
                    },
                ]);

                let custom_url = "";
                if (window.is_real_truck) {
                    custom_url =
                        "https://realtruck.com/checkout/cart/?3rdParty=seatcoversolutions";
                }
                if (window.scs_custom_endpoint) {
                    custom_url = window.scs_custom_endpoint_url || "";
                }

                if (!custom_url || custom_url === "") {
                    console.error("No matches");
                    return;
                }

                const form = document.createElement("form");
                form.method = "POST";
                form.target = "_parent";
                form.action = custom_url;

                if (window.is_real_truck) {
                    element1 = document.createElement("input");
                    element1.value = raw;
                    element1.name = "body";
                    form.appendChild(element1);
                }
                if (window.scs_custom_endpoint) {
                    element1 = document.createElement("input");
                    element1.value = "SC";
                    element1.name = "LineCode";
                    form.appendChild(element1);

                    const element2 = document.createElement("input");
                    element2.value = await getCustomSku(
                        currentAppData,
                        selectedVariant.node.sku,
                    );
                    element2.name = "PartNumber";
                    form.appendChild(element2);

                    const element3 = document.createElement("input");
                    element3.value = "1";
                    element3.name = "Quantity";
                    form.appendChild(element3);

                    const element4 = document.createElement("input");
                    element4.value =
                        currentAppData?.product?.title + " - " + selectedVariant.node.title;
                    element4.name = "Name";
                    form.appendChild(element4);

                    const element5 = document.createElement("input");
                    element5.value = `${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model}`;
                    element5.name = "Fitment";
                    form.appendChild(element5);

                    // const configuration = getConfiguredAnswers();
                    // if (configuration) {
                    //     const elementConfig = document.createElement("input");
                    //     elementConfig.value = configuration;
                    //     elementConfig.name = "Configuration";
                    //     form.appendChild(elementConfig);
                    // }

                    const queryParameters = new URLSearchParams(window.location.search);
                    const SessionId = queryParameters.get("SessionId") ?? "";
                    const element6 = document.createElement("input");
                    element6.value = SessionId;
                    element6.name = "SessionId";
                    form.appendChild(element6);
                }

                document.body.appendChild(form);

                document.body.appendChild(form);

                form.submit();

                return;
            }

            let has3Bonus = false;
            if (isBundle(currentAppData)) {
                has3Bonus = true;
            } else if (isFront(currentAppData)) {
                has3Bonus = true;
            } else if (isRear(currentAppData)) {
                has3Bonus = true;
            }

            const gid = getGid();
            const items: any[] = [];

            const props1 = {
                _gid: gid,
                _new_sku: getNewSku(currentAppData),
                _seat: currentAppData.seat,
                _color: currentAppData.color,
                "Your Vehicle":
                    `${currentAppData.year} ${currentAppData.make} ${currentAppData.model}`.trim(),
                _your_vehicle:
                    `${currentAppData.year} ${currentAppData.make} ${currentAppData.model}`.trim(),
                _vehicle_type: currentAppData?.check?.vehicle_type,
            };
            const partNumber = getNewSku(currentAppData) || getNewPartNumber(currentAppData);
            if (partNumber) {
                props1['Part #'] = partNumber;
                props1['_part_no'] = partNumber;
            }
            if (window.scs_black_friday_2025) {
                props1['_widget_id'] = window.scs_promo_main_widget_id;//'5090101';
            }

            if (preOrderClick) {
                setIsPreOrderClick(true);
            }

            if (preOrderClick && variantMetafields?.preorder_enabled === 'true') {
                props1['_pre_order'] = 'yes';
                props1['_pre_order_date'] = variantMetafields?.preorder_ship_date || '';
                props1['Preorder Ship Date'] = variantMetafields?.preorder_ship_date || '';
            }

            // add _components property for analytics to identify which components were used to add the product to cart
            let _components = (currentAppData?.seat && currentAppData?.color)
                ? currentAppData?.check?.availability?.[currentAppData.seat]?.components?.[currentAppData.color]
                : undefined;
            if (currentAppData?.seat && currentAppData?.color) {
                const skuMapSeatKey = resolveAvailabilitySeatKey(currentAppData.seat, currentAppData.sku_mapping_availability);
                const skuMapComponents = currentAppData?.sku_mapping_availability?.[skuMapSeatKey]?.prekit?.[currentAppData.color]?.components;
                if (skuMapComponents !== undefined && skuMapComponents !== null) {
                    _components = skuMapComponents;
                }
            }
            if (_components) {
                props1['_components'] = Array.isArray(_components) ? _components.join(',') : _components;
            }

            const _isVirtual = currentAppData?.seat && currentAppData?.color &&
                currentAppData?.check?.availability?.[currentAppData.seat]?.["prekit"]?.[currentAppData.color]?.virtual === true;
            if (_isVirtual) {
                props1['_virtual'] = 'true';
            }


            const seatCoverId = getSeatCoverId(currentAppData);

            const frontIsSkipped = isCustomRearAvailable(currentAppData) && !currentAppData?.seat;
            let effectiveParentId = seatCoverId;
            if (frontIsSkipped && currentAppData?.customRearAddons?.length > 0) {
                const rearProduct = currentAppData.customRearProduct;
                if (rearProduct?.variants) {
                    const firstKey = currentAppData.customRearAddons[0];
                    const firstSeatName = firstKey === 'rear_seat' ? 'Custom 2nd Row'
                        : firstKey === '2nd_row' ? 'Custom 2nd Row'
                        : 'Custom 3rd Row';
                    const selectedColor = currentAppData?.color;
                    const firstVariant = rearProduct.variants.edges?.find((v: any) =>
                        v.node.selectedOptions.some((o: any) => o.name === 'Seats' && o.value === firstSeatName) &&
                        (!selectedColor || v.node.selectedOptions.some((o: any) => o.name === 'Color' && o.value === selectedColor))
                    ) || rearProduct.variants.edges?.find((v: any) =>
                        v.node.selectedOptions.some((o: any) => o.name === 'Seats' && o.value === firstSeatName)
                    );
                    if (firstVariant) {
                        effectiveParentId = firstVariant.node.id.replace('gid://shopify/ProductVariant/', '');
                    }
                }
            }

            const obj1 = {
                quantity: 1,
                id: seatCoverId,
                
                properties: getProperties(props1),
            };
            if (currentAppData.show_offer && currentAppData.show_upsell) {
                obj1.properties["_widget_id"] = '5090100';
                window.Shopify.analytics.publish("show_upsell_redemption", {
                    campaign_id: 'double_offer',
                    vehicle:
                        `${currentAppData.year} ${currentAppData.make} ${currentAppData.model}`.trim(),
                    year: currentAppData.year,
                    make: currentAppData.make,
                    model: currentAppData.model,
                    trim: currentAppData.trim,
                    cab: currentAppData.cab,
                    seat: currentAppData.seat,
                    color: currentAppData.color,
                });
            }
            if (has3Bonus) {
                obj1.properties["_has_bonus"] = has3Bonus;
            }

             const _dbg_has_rm = currentAppData?.check?.has_rm === true;
            const _dbg_isBundle = (currentAppData?.seat?.indexOf('Bundle') !== -1);
            const _dbg_isRear = (currentAppData?.seat?.indexOf('Universal Back Bench') !== -1);
            const _dbg_color = currentAppData?.color;
            const _dbg_colorBlack = typeof _dbg_color === 'string' && _dbg_color.includes('Black');
            const _dbg_condition = _dbg_has_rm && (_dbg_isBundle || _dbg_isRear) && _dbg_colorBlack;

            if (_dbg_condition) {
                obj1.properties['_has_bl_rm'] = 'yes';
            }

            if (!isCustomRearAvailable(currentAppData) || currentAppData?.seat) {
                items.push(obj1);
            }

            // Push customRearAddons BEFORE any child items (bonus, addons, vehicleAddons) so that
            // when frontIsSkipped the parent rear item (index 0) appears first in the array.
            // Shopify's /cart/add.js requires the parent to precede its children when referencing
            // by variant_id; otherwise it errors with "Cannot reference existing parent lines by variant_id."
            if (currentAppData?.customRearAddons && currentAppData.customRearAddons.length > 0) {
                const rearProduct = currentAppData.customRearProduct;
                if (rearProduct && rearProduct.variants) {
                    const selectedColor = currentAppData.color;
                    currentAppData.customRearAddons.forEach((addonKey, index) => {
                        const seatName = addonKey === 'rear_seat' ? 'Custom 2nd Row'
                            : addonKey === '2nd_row' ? 'Custom 2nd Row'
                            : 'Custom 3rd Row';

                        const matchingVariant = rearProduct.variants.edges?.find(v =>
                            v.node.selectedOptions.some(o => o.name === 'Seats' && o.value === seatName) &&
                            (!selectedColor || v.node.selectedOptions.some(o => o.name === 'Color' && o.value === selectedColor))
                        ) || rearProduct.variants.edges?.find(v =>
                            v.node.selectedOptions.some(o => o.name === 'Seats' && o.value === seatName)
                        );

                        if (matchingVariant) {
                            const isParentItem = frontIsSkipped && index === 0;
                            const rearItem: any = {
                                quantity: 1,
                                id: matchingVariant.node.id.replace('gid://shopify/ProductVariant/', ''),
                                properties: getProperties({
                                    _source: `pdp_multi_step`,
                                    _seat: currentAppData.seat,
                                    _color: currentAppData.color,
                                    _session_id: sessionService.getSessionId(),
                                    _custom_rear: 'yes',
                                    _rear_type: seatName,
                                    _split_ship: 'yes',
                                    _gid: gid,
                                    _widget_id: window.scs_promo_main_widget_id,
                                    "Your Vehicle":
                                        `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                                    _your_vehicle:
                                        `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                                }),
                            };
                            if (!isParentItem && !shouldIgnoreParent(rearItem.id)) {
                                rearItem.parent_id = effectiveParentId;
                            }
                            items.push(rearItem);
                        }
                    });
                }
            }

            let cc = "STR09FR";
            const activePromoCode = getActivePromoCode();
            const activePromoVariants = activePromoCode ? await fetchGiftSetVariants(activePromoCode) : [];

            if (activePromoVariants.length > 0) {
                cc = activePromoCode as string;
                activePromoVariants.forEach(({ id, freeQuantity }) => {
                    items.push(
                        getItemObj(numericVariantId(id), currentAppData, {
                            _gid: gid,
                            _source: `pdp_multi_step`,
                            _bonus_type: "GiftSetPromo",
                            _promo_code: activePromoCode,
                            _widget_id: window.scs_widget_id ? window.scs_widget_id : "gift-set-promo",
                        }, effectiveParentId, freeQuantity),
                    );
                });
            } else if (window.scs_black_friday_2025 === true || (window.scs_ultimate_upgrade === true && currentAppData?.ultimate_upgrade === true)) {
                const widget_id = window.scs_widget_id
                    ? window.scs_widget_id
                    : "4100206";

                let _bonus = "";
                if ((window.scs_ultimate_upgrade === true && currentAppData?.ultimate_upgrade === true)) {
                    _bonus = "ultimate-offer";
                }
                if (window.scs_black_friday_2025) {
                    _bonus = "bf2025";
                }

                if (window.scs_bonus_product) {
                    window.scs_bonus_product.split(",").map((raw) => {
                        const { id, quantity } = parseBonusProductId(raw);
                        if (id === 'WHEEL_COVER') {
                            const wheelId = getSeatId();
                            const obj2: any = {
                                quantity: quantity,
                                id: wheelId,
                                discount_code: cc,
                                properties: getProperties({
                                    _gid: gid,
                                    _source: `pdp_multi_step`,
                                    _bonus: _bonus,
                                    _bonus_type: "GWPBonus",
                                    _widget_id: widget_id,
                                }),
                            };
                            if (!shouldIgnoreParent(wheelId)) {
                                obj2.parent_id = effectiveParentId;
                            }
                            items.push(obj2);
                        } else {
                            items.push(
                                getItemObj(id, currentAppData, {
                                    _gid: gid,
                                    _source: `pdp_multi_step`,
                                    _bonus: _bonus,
                                    _bonus_type: "GWPBonus",
                                    _widget_id: widget_id,
                                }, effectiveParentId, quantity),
                            );
                        }
                    });
                }
            } else if (window.scs_show_new_year_promo_section) {
                const widget_id = window.scs_widget_id
                    ? window.scs_widget_id
                    : "4100206";

                // console.log("add for scs_show_new_year_promo_section");
                cc = window.scs_bonus_discount || "";

                if (window.scs_bonus_product) {
                    window.scs_bonus_product.split(",").map((raw) => {
                        const { id, quantity } = parseBonusProductId(raw);
                        if (id === 'WHEEL_COVER') {
                            const wheelId = getSeatId();
                            const obj2: any = {
                                quantity: quantity,
                                id: wheelId,
                                discount_code: cc,
                                properties: getProperties({
                                    _gid: gid,
                                    _source: `pdp_multi_step`,
                                    _bonus: "current-offer",
                                    _bonus_type: "GWPBonus",
                                    _widget_id: widget_id,
                                }),
                            };
                            if (!shouldIgnoreParent(wheelId)) {
                                obj2.parent_id = effectiveParentId;
                            }
                            items.push(obj2);
                        } else {
                            items.push(
                                getItemObj(id, currentAppData, {
                                    _gid: gid,
                                    _source: `pdp_multi_step`,
                                    _bonus: "current-offer",
                                    _bonus_type: "GWPBonus",
                                    _widget_id: widget_id,
                                }, effectiveParentId, quantity),
                            );
                        }
                    });
                }
            } else {
                if (window.scs_show_bf_section) {
                    cc = window.scs_bonus_discount || "";
                    if (window.scs_bonus_product?.indexOf("getSeatId") !== -1) {
                        const wheelId = getSeatId();
                        const obj2: any = {
                            _gid: gid,
                            quantity: 1,
                            id: wheelId,
                            discount_code: cc,
                            properties: getProperties({
                                _source: `pdp_multi_step`,
                                _bonus_type: "GWPBonus",
                                _widget_id: "4100204",
                            }),
                        };
                        if (!shouldIgnoreParent(wheelId)) {
                            obj2.parent_id = effectiveParentId;
                        }
                        items.push(obj2);
                    } else {
                        if (window.scs_bonus_product) {
                            window.scs_bonus_product.split(",").map((raw) => {
                                const { id, quantity } = parseBonusProductId(raw);
                                items.push(
                                    getItemObj(id, currentAppData, {
                                        _gid: gid,
                                        _bonus_type: "GWPBonus",
                                        _widget_id: "4100204",
                                    }, effectiveParentId, quantity),
                                );
                            });
                        }
                    }
                } else {
                    if (window.scs_show_earlybf_section) {
                        items.push(
                            getItemObj(49714091327780, currentAppData, {
                                _gid: gid,
                                _bonus_type: "GWPBonus",
                                _widget_id: "4100203",
                            }, effectiveParentId),
                        );
                        items.push(
                            getItemObj(49007184019748, currentAppData, {
                                _gid: gid,
                                _bonus_type: "GWPBonus",
                                _widget_id: "4100203",
                            }, effectiveParentId),
                        );
                        cc = "EARLYBFCM";
                    } else {
                        // if (isBundle(currentAppData)) {
                        //     items.push(getItemObj(45340255387940, currentAppData));
                        //     items.push(getItemObj(49714091327780, currentAppData));
                        //     items.push(getItemObj(49007184019748, currentAppData));
                        // } else if (isFront(currentAppData)) {
                        //     items.push(getItemObj(45340255387940, currentAppData));
                        //     items.push(getItemObj(49714091327780, currentAppData));
                        // } else if (isRear(currentAppData)) {
                        //     items.push(getItemObj(45340255387940, currentAppData));
                        // }
                    }
                }
            }

            if (currentAppData?.with_bonus) {
                const bonusId = getSeatId();
                const obj2: any = {
                    quantity: 1,
                    id: bonusId,
                    discount_code: cc,
                    properties: getProperties({
                        _gid: gid,
                        _source: `pdp_multi_step`,
                    }),
                };
                if (!shouldIgnoreParent(bonusId)) {
                    obj2.parent_id = effectiveParentId;
                }
                items.push(obj2);
            }

            if (currentAppData?.addons) {
                const upsellWidgetIds = (window.scs_upsells_widget_ids || '').split(',');

                const addons = currentAppData?.addons.split(',');
                addons?.map((addon) => {
                    let id = addon;
                    if (addon === "Jump Seat Cover") {
                        id = getJumpSeatCoverId(currentAppData.color);
                    }

                    // For pet cover upsells, ensure the correct vehicle-type variant is used
                    const vehicleType = currentAppData?.check?.vehicle_type;
                    if (vehicleType) {
                        const upsells = (window as any).scs_upsells || [];
                        const petCoverUpsell = upsells.find((u: any) =>
                            u.title?.toLowerCase().includes('pet') &&
                            u.variants?.some((v: any) => String(v.id) === String(id))
                        );
                        if (petCoverUpsell && petCoverUpsell.variants?.length > 1) {
                            const isTruck = vehicleType === 'Truck';
                            const targetVariant = isTruck
                                ? petCoverUpsell.variants.find((v: any) => v.title?.toLowerCase().includes('truck'))
                                : petCoverUpsell.variants.find((v: any) =>
                                    v.title?.toLowerCase().includes('car') || v.title?.toLowerCase().includes('suv')
                                  );
                            if (targetVariant) id = String(targetVariant.id);
                        }
                    }

                    const upsellIndex = ((window as any).scs_upsells || []).findIndex(
                        (u: any) => u.variants?.some((v: any) => String(v.id) === String(id))
                    );
                    const addonWidgetId = upsellIndex !== -1 ? upsellWidgetIds[upsellIndex]?.trim() : undefined;

                    const addonProps: any = {
                        _source: `pdp_multi_step`,
                        _seat: currentAppData.seat,
                        _color: currentAppData.seat,
                        _session_id: sessionService.getSessionId(),
                        "Your Vehicle":
                            `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                        _your_vehicle:
                            `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                    };
                    if (addonWidgetId) {
                        addonProps._widget_id = addonWidgetId;
                    }

                    const obj1: any = {
                        quantity: 1,
                        id: id,
                        properties: getProperties(addonProps),
                    };
                    if (!shouldIgnoreParent(id)) {
                        obj1.parent_id = effectiveParentId;
                    }
                    items.push(obj1);
                })
            }

            if (currentAppData?.selectedVehicleAddons && currentAppData.selectedVehicleAddons.length > 0) {
                // Defense in depth: never let an addon that duplicates a bundle
                // component (or is manually flagged out-of-stock/off-site) reach the cart.
                const excludedAddonSkus = getExcludedAddonSkus(currentAppData);
                const allowedVehicleAddons = currentAppData.selectedVehicleAddons.filter(
                    (addon) => !excludedAddonSkus.includes(addon.sku),
                );
                allowedVehicleAddons.forEach((addon) => {
                    const vehicleAddonItem: any = {
                        quantity: 1,
                        id: addon.variantId,
                        properties: getProperties({
                            _source: `pdp_multi_step`,
                            _addon_sku: addon.sku,
                            _seat: currentAppData.seat,
                            _color: currentAppData.color,
                            _session_id: sessionService.getSessionId(),
                            "Your Vehicle":
                                `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                            _your_vehicle:
                                `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                        }),
                    };
                    if (!shouldIgnoreParent(addon.variantId)) {
                        vehicleAddonItem.parent_id = effectiveParentId;
                    }
                    items.push(vehicleAddonItem);
                });
            }

            const attributes = {};

            if (preOrderClick && variantMetafields?.preorder_enabled === 'true') {
                attributes['Preorder Ship Date'] = variantMetafields?.preorder_ship_date || '';
            }
            if (window.scs_ship_by_date_format2) {
                // ships_by must reflect the cart's worst-case (furthest-out) ship date, not
                // just the item being added now — the checkout Function that reads this
                // attribute has no real clock of its own (Shopify Functions run in a
                // deterministic sandbox), so it trusts this value as-is rather than
                // recomputing across cart lines itself.
                let cartWideShipByDate = shipByDate;
                try {
                    const holidays = holidaysQuery.data ?? await fetchHolidays().catch(() => []);
                    const existingCartRes = await fetch('/cart.js');
                    if (existingCartRes.ok) {
                        const existingCart = await existingCartRes.json();
                        const existingSkus = (existingCart.items || []).map((i) => i.sku).filter(Boolean);
                        const componentSkus = getComponentSkus(currentAppData);
                        const maxAcrossCart = getMaxShipByDate([partNumber, ...componentSkus, ...existingSkus], undefined, holidays);
                        if (maxAcrossCart) {
                            cartWideShipByDate = maxAcrossCart;
                        }
                    }
                } catch (e) {
                    // Network hiccup fetching the existing cart — fall back to just this
                    // item's date rather than blocking add-to-cart.
                }
                if (cartWideShipByDate) {
                    attributes['ships_by'] = cartWideShipByDate.iso;
                }
            }
            attributes['_session_id'] = sessionService.getSessionId();

            if (window.scs_biz2_flow === true) {
                attributes['_scsbiz2'] = 'yes';
                attributes['scs_biz2_flow'] = 'yes';
            }

           

            const data = {
                items: items,
                attributes: attributes
            };
            // loadingOverlay($(".cart-container form"), "show");

            if (__DRAFT_ORDER__) {
                const updatedItems = getDraftCartStore().addItems(data.items);
                setDraftCartItems(updatedItems);
                setDraftCartAttributes(attributes);
                setDraftCartOpen(true);
                setLoading(false);
                return;
            }

            if (window.is_embedded === true) {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append(
                    "X-Shopify-Storefront-Access-Token",
                    import.meta.env.VITE_SHOPIFY_STOREFRONT_TOKEN,
                );

                const lines = data.items.map((item) => {
                    return {
                        merchandiseId: "gid://shopify/ProductVariant/" + item.id,
                        quantity: item.quantity,
                        attributes: item.properties
                            ? Object.keys(item.properties).map((key) => {
                                return {
                                    key: key,
                                    value: item.properties[key],
                                };
                            })
                            : [],
                    };
                });

                const graphql = JSON.stringify({
                    query:
                        "mutation cartCreate($input: CartInput) {\n  cartCreate(input: $input) {\n    cart {\n      # Cart fields\n      id\n      checkoutUrl\n    }\n    userErrors {\n      field\n      message\n    }\n   \n  }\n}",
                    variables: {
                        input: {
                            lines: lines,
                            metafields: [
                                {key: "cart_type", type: "string", value: "embedded"},
                                {key: "session_id", type: "string", value: sessionService.getSessionId()},
                            ],
                            note: "Date of Cart: " + new Date().toISOString(),
                        },
                    },
                });
                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: graphql,
                    redirect: "follow",
                };

                fetch(
                    import.meta.env.VITE_SHOPIFY_STORE_URL,
                    requestOptions,
                )
                    .then((response) => response.json())
                    .then((result) => {
                        window.location.href = result?.data?.cartCreate?.cart?.checkoutUrl;
                    })
                    .catch((error) => console.error(error));

                return;
            }

            if (import.meta.env.DEV) {
                console.log('add to cart:', data);
                const overlay = document.createElement('div');
                overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.65);z-index:99999;display:flex;align-items:flex-start;justify-content:center;padding:40px 20px;overflow:auto;';
                const box = document.createElement('div');
                box.style.cssText = 'background:#1e1e1e;color:#d4d4d4;padding:24px 28px;border-radius:10px;max-width:1000px;width:100%;font-family:system-ui,-apple-system,sans-serif;font-size:13px;line-height:1.6;box-shadow:0 8px 40px rgba(0,0,0,0.6);';
                
                const title = document.createElement('div');
                title.style.cssText = 'color:#4ec9b0;font-size:17px;font-weight:bold;margin-bottom:20px;letter-spacing:0.5px;';
                title.textContent = '🛒 [DEV] Add to Cart Items';
                title.role = 'heading';
                
                // Create table
                const table = document.createElement('table');
                table.style.cssText = 'width:auto;min-width:600px;border-collapse:collapse;margin-bottom:20px;table-layout:auto;';
                
                // Table header
                const thead = document.createElement('thead');
                const headerRow = document.createElement('tr');
                ['Variant ID', 'Product Title', 'Variant Title', 'SKU', 'Qty', 'Properties'].forEach((headerText) => {
                    const th = document.createElement('th');
                    th.textContent = headerText;
                    th.style.cssText = `text-align:left;padding:10px 12px;border-bottom:2px solid #383838;color:#9cdcfe;font-weight:600;white-space:nowrap;font-size:12px;`;
                    headerRow.appendChild(th);
                });
                thead.appendChild(headerRow);
                table.appendChild(thead);
                
                // Table body
                const tbody = document.createElement('tbody');
                
                const items = Array.isArray(data.items) ? data.items : [data];
                const variantCache = new Map();
                const CACHE_TTL = 1000 * 60 * 60;
                
                // Helper to fetch real titles from Shopify GraphQL
                async function fetchVariantTitle(variantId) {
                    if (variantCache.has(variantId) && Date.now() - variantCache.get(variantId).fetchedAt < CACHE_TTL) {
                        return variantCache.get(variantId);
                    }
                    try {
                        const storeUrl = import.meta.env.VITE_SHOPIFY_STORE_URL || window.location.origin;
                        const res = await fetch(`${storeUrl}`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                query: `query($id:ID!){node(id:$id){...on ProductVariant{title sku product{title}}}}`,
                                variables: { id: `gid://shopify/ProductVariant/${variantId}` }
                            })
                        });
                        const data = await res.json();
                        const result = {
                            productTitle: data?.data?.node?.product?.title || 'Unknown Product',
                            variantTitle: data?.data?.node?.title || 'Unknown Variant',
                            sku: data?.data?.node?.sku || '-',
                            fetchedAt: Date.now()
                        };
                        variantCache.set(variantId, result);
                        return result;
                    } catch {
                        return { productTitle: 'Unknown Product', variantTitle: 'Unknown Variant', sku: '-', fetchedAt: Date.now() };
                    }
                }

                items.forEach((item, index) => {
                    const row = document.createElement('tr');
                    row.style.cssText = index % 2 === 0 ? 'background:#252526;' : 'background:#1e1e1e;';
                    
                    // Create cells with references
                    const tdNum = document.createElement('td');
                    tdNum.textContent = item.id?.toString() || '-';
                    tdNum.style.cssText = 'padding:10px 12px;border-bottom:1px solid #333;vertical-align:top;color:#ffffff;font-size:11px;font-family:monospace;white-space:nowrap;';
                    
                    const tdProduct = document.createElement('td');
                    tdProduct.textContent = item.title || 'Loading...';
                    tdProduct.style.cssText = 'padding:10px 12px;border-bottom:1px solid #333;vertical-align:top;color:#ffffff;';
                    
                    const tdVariant = document.createElement('td');
                    tdVariant.textContent = item.variant_title || 'Loading...';
                    tdVariant.style.cssText = 'padding:10px 12px;border-bottom:1px solid #333;vertical-align:top;color:#ffffff;';

                    const tdSku = document.createElement('td');
                    tdSku.textContent = item.sku || 'Loading...';
                    tdSku.style.cssText = 'padding:10px 12px;border-bottom:1px solid #333;vertical-align:top;color:#ce9178;font-family:monospace;white-space:nowrap;';

                    const tdQty = document.createElement('td');
                    tdQty.textContent = item.quantity?.toString() || '1';
                    tdQty.style.cssText = 'padding:10px 12px;border-bottom:1px solid #333;vertical-align:top;color:#ffffff;';

                    const tdProps = document.createElement('td');
                    tdProps.textContent = item.properties ? Object.entries(item.properties).map(([k, v]) => `${k}: ${v}`).join(', ') : '-';
                    tdProps.style.cssText = 'padding:10px 12px;border-bottom:1px solid #333;vertical-align:top;color:#ffffff;';

                    // Apply consistent font to all cells
                    [tdNum, tdProduct, tdVariant, tdSku, tdQty, tdProps].forEach(td => {
                        td.style.fontSize = '12px';
                        td.style.verticalAlign = 'top';
                    });

                    row.appendChild(tdNum);
                    row.appendChild(tdProduct);
                    row.appendChild(tdVariant);
                    row.appendChild(tdSku);
                    row.appendChild(tdQty);
                    row.appendChild(tdProps);

                    tbody.appendChild(row);

                    // Fetch and update titles/sku if variant id exists
                    if (item.id && !item.title) {
                        fetchVariantTitle(item.id).then(({ productTitle, variantTitle, sku }) => {
                            tdProduct.textContent = productTitle;
                            tdVariant.textContent = variantTitle;
                            tdSku.textContent = sku;
                        });
                    }
                });
                
                table.appendChild(tbody);
                
                // Raw JSON toggle
                const toggleBtn = document.createElement('button');
                toggleBtn.textContent = 'Show Raw JSON';
                toggleBtn.style.cssText = 'display:inline-block;margin-bottom:20px;padding:6px 14px;background:#3c3c3c;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:12px;';
                
                const rawJsonContainer = document.createElement('div');
                rawJsonContainer.style.display = 'none';
                
                const pre = document.createElement('pre');
                pre.style.cssText = 'margin:0;overflow:auto;max-height:40vh;background:#161616;padding:14px;border-radius:6px;font-family:monospace;font-size:11px;';
                pre.textContent = JSON.stringify(data, null, 2);
                rawJsonContainer.appendChild(pre);
                
                toggleBtn.onclick = () => {
                    if (rawJsonContainer.style.display === 'none') {
                        rawJsonContainer.style.display = 'block';
                        toggleBtn.textContent = 'Hide Raw JSON';
                    } else {
                        rawJsonContainer.style.display = 'none';
                        toggleBtn.textContent = 'Show Raw JSON';
                    }
                };
                
                const closeBtn = document.createElement('button');
                closeBtn.textContent = 'Close';
                closeBtn.style.cssText = 'display:inline-block;margin-top:8px;padding:8px 24px;background:#0078d4;color:#fff;border:none;border-radius:5px;cursor:pointer;font-size:13px;';
                closeBtn.onclick = () => document.body.removeChild(overlay);
                overlay.onclick = (e) => { if (e.target === overlay) document.body.removeChild(overlay); };
                
                box.appendChild(title);
                box.appendChild(table);
                box.appendChild(toggleBtn);
                box.appendChild(rawJsonContainer);
                box.appendChild(closeBtn);
                overlay.appendChild(box);
                document.body.appendChild(overlay);
                setLoading(false);
                return;
            }

            fetch("/cart/add.js", {
                method: "POST",
                body: JSON.stringify(data),
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With":
                        "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
                },
            })
                .then((response) => response.json())
                .then((resp) => {
                    selectPetCoverVariantInCartDrawer(currentAppData?.check?.vehicle_type);

                    if (
                        activePromoVariants.length > 0 ||
                        currentAppData?.with_bonus ||
                        window.scs_show_earlybf_section ||
                        window.scs_show_bf_section ||
                        window.scs_show_str_section ||
                        window.scs_show_new_year_promo_section
                    ) {
                        //fetch(`/discount/${cc}`)
                        fetch(`/checkout?discount=${cc}`)
                            .then(function () {
                                // After the discount code has been applied, force the cart to update so the discount is visible instantly
                                setTimeout(function () {
                                    fetch("/cart/update.js", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                            updates: {},
                                        }),
                                    }).then(function () {
                                        setLoading(false);
                                        setDoubleOffer();

                                    });
                                }, 500);
                            })
                            .catch(function (error) {
                                console.error("Error:", error);
                                setLoading(false);

                                setTimeout(function () {
                                    fetch("/cart/update.js", {
                                        method: "POST",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                            updates: {},
                                        }),
                                    }).then(function () {
                                        setLoading(false);
                                        setDoubleOffer();
                                    });
                                }, 500);
                            });
                    } else {
                        setLoading(false);
                        setDoubleOffer();
                    }
                    setIsPreOrderClick(false);
                })
                .catch(function (error) {
                    // console.log("Request failed", error);
                    setLoading(false);
                    setIsPreOrderClick(false);
                });
        } else {
            if (currentAppData?.step === 1) {
                if (
                    !currentAppData.year ||
                    !currentAppData.make ||
                    !currentAppData.model
                ) {
                    alert(`Please select your vehicle`);
                    return;
                }
                setTimeout(function () {
                    setCurrentAppData((prevState) => {
                        return {
                            ...prevState,
                            step: prevState && prevState.step ? prevState.step + 1 : 1,
                            seat: "",
                        };
                    });
                    setTimeout(function () {
                        if (window.innerWidth < 768) {
                            const element = document.getElementById("step_2");
                            element?.scrollIntoView({
                                behavior: "smooth",
                            });
                        }
                    }, 50);
                }, 100);

                return;
            }

            setTimeout(function () {
                if (currentAppData?.step === 2) {
                    if (window.innerWidth < 768) {
                        const element = document.getElementById(`${styles.step_3}`);
                        element?.scrollIntoView({
                            behavior: "smooth",
                        });
                    }
                }
            }, 200);

            setCurrentAppData((prevState) => {
                return {
                    ...prevState,
                    step: prevState && prevState.step ? prevState.step + 1 : 1,
                };
            });
        }
    };

    const deps = [
        currentAppData?.check,
        currentAppData?.step,
        currentAppData?.make,
        currentAppData?.model,
        currentAppData?.year,
        currentAppData?.trim,
        currentAppData?.has_trims,
        currentAppData?.cab,
        currentAppData?.has_cabs,
        currentAppData?.seat,
        currentAppData?.color,
        currentAppData?.configurator_complete,
        currentAppData?.customRearAddons,
    ];

    // useWhatChanged(deps, 'check, step, make, mode, year, trim, has_trims, cab, has_cabs, seat, color');
    useEffect(() => {
        //console.debug("StepNav: ", currentAppData);
        if (currentAppData?.step === 1) {
            if (currentAppData?.check) {
                if (
                    currentAppData?.year &&
                    currentAppData.make !== "" &&
                    currentAppData.model !== ""
                ) {
                    // Determine trim/cab requirements and set disabled accordingly.
                    // checkTrimAndCab also returns a `newStep`, but nothing here has ever
                    // consumed it — step-1→2 auto-advance is handled separately by the
                    // canMoveToStep2 mechanism in Step1/Step1New.
                    const res = checkTrimAndCab(1);
                    setDisabled(res.missingRequired);
                } else {
                    setDisabled(true);
                }
            } else {
                setDisabled(true);
            }
        }
        if (currentAppData?.step === 2) {
            if (!currentAppData?.check) {
                setDisabled(true);
                return;
            }
            // In biz2+vehicle_configurator, configurator_complete is managed for step 3 (questions),
            // not step 2 (seat selection). Don't block step 2 on configurator state.
            if (currentAppData?.configurator_complete === false && !(window.scs_vehicle_configurator && window.scs_biz2)) {
                setDisabled(true);
                return;
            }
            const seat = currentAppData.seat;
            if (seat != undefined && seat != "") {
                // For fronts-only vehicles only 'Front Seats' is a valid seat type;
                // for fronts-only custom products only 'First Row' is valid.
                // Guard against a stale 'Bundle' (or other) seat value being used
                // to add to cart while the auto-correction in Step3New is pending.
                const compat = currentAppData.check.compatibility;
                const isFrontsOnlyRegular = (compat === 'HF' || compat === 'AF' || compat === 'F' || compat === 'BF');
                const isFrontsOnlyCustomProduct = isCustomFront(currentAppData);
                if ((isFrontsOnlyRegular && seat !== 'Front Seats') ||
                    (isFrontsOnlyCustomProduct && seat !== 'First Row')) {
                    // console.log('d4-invalid-seat');
                    setDisabled(true);
                } else {
                    // console.log('d4');
                    setDisabled(false);
                }
            } else {
                // console.log('d5');
                setDisabled(true);
            }
        } else if (currentAppData?.step >= 2) {
            // Compose required checks (color + trim/cab when applicable) and set disabled once.
            if (!currentAppData?.check) {
                setDisabled(true);
                return;
            }

            // Determine trim/cab missing requirement without allowing checkTrimAndCab to mutate disabled directly.
            let trimCabMissing: boolean;
            if (currentAppData?.has_trims) {
                trimCabMissing = (!currentAppData?.trim || currentAppData?.trim === "");
                if (currentAppData?.has_cabs) {
                    trimCabMissing = trimCabMissing || (!currentAppData?.cab || currentAppData?.cab === "");
                }
            } else {
                if (currentAppData?.has_cabs) {
                    trimCabMissing = (!currentAppData?.cab || currentAppData?.cab === "");
                } else {
                    trimCabMissing = false;
                }
            }

            const colorMissing = !currentAppData.color || currentAppData.color === "";
            // In biz2+vehicle_configurator flow, treat undefined as pending (not yet answered).
            // Elsewhere, only block on explicit false to avoid regressing non-configurator flows.
            const configuratorPending = (window.scs_vehicle_configurator && window.scs_biz2)
                ? currentAppData?.configurator_complete !== true
                : currentAppData?.configurator_complete === false;

            // If custom rear addons are selected with no front seat, color and configurator are not required
            const frontSkippedWithRearAddons = isCustomRearAvailable(currentAppData)
                && !currentAppData?.seat
                && currentAppData?.customRearAddons?.length > 0;

            // When the configurator is complete it replaces trim/cab selection — don't block on trimCabMissing.
            const effectiveTrimCabMissing = currentAppData?.configurator_complete === true ? false : trimCabMissing;
            const finalDisabled = effectiveTrimCabMissing || (frontSkippedWithRearAddons ? false : (colorMissing || configuratorPending));
            setDisabled(finalDisabled);
        }
    }, deps);

    function checkTrimAndCab(newStep) {
        // Return an object describing the next step and whether required vehicle options are missing
        let missingRequired: boolean;

        if (currentAppData?.has_trims) {
            missingRequired = (!currentAppData?.trim || currentAppData?.trim === "");
            if (currentAppData?.has_cabs) {
                missingRequired = missingRequired || (!currentAppData?.cab || currentAppData?.cab === "");
            }

            if (!missingRequired) {
                newStep = 2;
            }
        } else {
            // No trims for this model. If there are cab sizes, require a cab selection.
            if (currentAppData?.has_cabs) {
                missingRequired = (!currentAppData?.cab || currentAppData?.cab === "");
            } else {
                missingRequired = false;
            }
        }

        return { newStep, missingRequired };
    }

    function getButtonText(comparePrice, price): JSX.Element {
        if (window.scs_custom_style == "style01") {
            if (currentAppData?.step == 3 || window.scs_new_design_2026 === true) {
                return (
                    <>
                        Add To Cart - {comparePrice && parseFloat(comparePrice.replace(/[^0-9.]/g, '')) > 0 ? <s data-testid="add-to-cart-compare-price">{comparePrice}</s> : ""} <span data-testid="add-to-cart-price">{price}</span>
                    </>
                );
            }

            if (currentAppData?.step == 1) {
                return <>Select Seat Options</>;
            }
            if (currentAppData?.step == 2) {
                return <>Select Color Options</>;
            }

            
        } else {
            if (currentAppData?.step == 3) {
                return <>Add To Cart</>;
            }
        }

        return <>Next Step</>;
    }

    function getProperties(params: ScsProperties) {
        const newParams: CustomScsParams = {};
        if (window.sessionStorage.getItem("attribution")) {
            newParams._scs_attribution =
                window.sessionStorage.getItem("attribution") || "";
        }
        if (window.sessionStorage.getItem("utm_source")) {
            newParams._scs_utm_source =
                window.sessionStorage.getItem("utm_source") || "";
        }
        if (window.sessionStorage.getItem("utm_campaign")) {
            newParams._scs_utm_campaign =
                window.sessionStorage.getItem("utm_campaign") || "";
        }
        if (window.sessionStorage.getItem("utm_medium")) {
            newParams._scs_utm_medium =
                window.sessionStorage.getItem("utm_medium") || "";
        }
        if (currentAppData?.year) {
            newParams._year = `${currentAppData.year}`;
        }
        if (currentAppData?.make) {
            newParams._make = `${currentAppData.make}`;
        }
        if (currentAppData?.model) {
            newParams._model = `${currentAppData.model}`;
        }
        if (currentAppData?.trim) {
            newParams._trim = currentAppData?.trim;
            //newParams.trim = currentAppData?.trim;
            newParams.Trim = `${currentAppData.trim}`;
        }
        if (currentAppData?.cab) {
            newParams._cab_size = currentAppData?.cab;
            newParams._cab = currentAppData?.cab;
            //newParams.cab_size = currentAppData?.cab;
            newParams.Trim = `${currentAppData.trim} / ${currentAppData.cab}`;
        }

        newParams._url = window.location.href;
        newParams._date_add_to_cart = new Date().toISOString();

        if (window.scs_ship_by_date_format2 && shipByDate) {
            newParams._ships_by = shipByDate.formatted;
        }

        try {
            const bodyClassList = document.body.classList;
            const accClass = Array.from(bodyClassList).find((c) =>
                c.startsWith("ACC_SCS_")
            );
            if (accClass) {
                newParams["_acc_template"] = accClass;
            }
        }
        catch (e) {
            console.error(e);
        }

        return {...params, ...newParams};
    }

    return (
        <>

            <section
                className={`${localStyles.section__step_nav} ${window.scs_custom_style ? styles.style01 : ""} ${window.scs_new_design_2026 ? styles.scs_new_design_2026 : ''} `}
                id={`step_nav`}
                onClick={handleDisabledNavClick}
            >
                {/*{currentAppData.step > 1 ?
                <button onClick={handleBack} className={`${localStyles.back}`}>Back</button> : ''}*/}
                <form action="/cart/add" method="post">
                    <input type="hidden" name="id" value={getSeatCoverId(currentAppData) || ""} />
                    <button
                        type="button"
                        onClick={() => handleNext()}
                        disabled={disabled || loading}
                        className={`${styles.btn} step_nav_scs_btn ${loading && !isPreOrderClick ? localStyles.loading : ""}`}
                        current-variant-id={getSeatCoverId(currentAppData) || ""}
                        data-current-variant-id={getSeatCoverId(currentAppData) || ""}
                    >
                        {loading && !isPreOrderClick ? <span className={` ${localStyles.loader}`}></span> : ""}
                        {currentAppData?.step && currentAppData?.step < 3 ? (
                            <span className={`${styles.btn_inner} step_nav_scs_btn_inner`}>
              {getButtonText(comparePrice, price)}
                                <svg
                                    width="10"
                                    height="15"
                                    viewBox="0 0 10 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                \n' + '
                <path
                    d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                    fill="white"
                />
                \n' + '
              </svg>
            </span>
                        ) : (
                            <span className={`${styles.btn_inner} step_nav_scs_btn_inner`}>
              {getButtonText(comparePrice, price)}
                                <svg
                                    width="10"
                                    height="15"
                                    viewBox="0 0 10 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                <path
                    d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                    fill="white"
                />
              </svg>
            </span>
                        )}
                    </button>
                </form>
                {giftBundleDisplay ? <GiftBundleStrip bundleDisplay={giftBundleDisplay} /> : null}
                {window.scs_offer_preorder && window.scs_fast_shipping_text && window.scs_new_design_2026 === true ? (<p style={{
    textAlign: "center",
    margin: "5px 0 0 0",
    fontSize: "12px",
}}>{window.scs_fast_shipping_text}</p>): ""}

                {window.scs_offer_preorder && variantMetafields?.preorder_enabled === 'true' && currentAppData?.step === 3 && (
                    <button
                            onClick={() => { handleNext(true); }}
                            disabled={disabled || loading}
                            className={`${styles.btn} ${localStyles.preorder_btn} ${loading && isPreOrderClick ? localStyles.loading : ""}`}
                    
                        >
                        {loading && isPreOrderClick ? <span className={`${localStyles.loader} ${localStyles.loader_black}`}></span> : ""}
                        <span className={`${styles.btn_inner} ${localStyles.btn_inner}`} style={{color: 'black'}}>
                            <span className={`${localStyles.preorder_text}`}>Add Pre-Order To Cart {comparePrice ? <s data-testid="preorder-compare-price">{comparePrice}</s> : ""} <span data-testid="preorder-price">{priceRawAmount > 0 ? formatShopifyMoney(priceRawAmount - 20) : ""}</span></span>
                            <span className={`${localStyles.preorder_info}`}>
                        Wait & Save: Estimated to Ship {variantMetafields?.preorder_ship_date || 'TBD'}
                    </span>
                        </span>
                    </button>
                )}
                
                {partNumber ? (<div className={`${localStyles.section__step_info}`}>
                    Part #: {`${partNumber}`}
                </div>): ''}


            </section>

            {__DRAFT_ORDER__ && (
                <DraftCartDrawer
                    open={draftCartOpen}
                    items={draftCartItems}
                    attributes={draftCartAttributes}
                    color={window.scs_ship_by_date_format2 ? (currentAppData?.color ?? '') : ''}
                    shipByDate={window.scs_ship_by_date_format2 ? (shipByDate?.formatted ?? null) : null}
                    onClose={() => setDraftCartOpen(false)}
                    onClear={() => {
                        getDraftCartStore().clear();
                        setDraftCartItems([]);
                        setDraftCartAttributes({});
                    }}
                    onCreated={() => {
                        getDraftCartStore().clear();
                        setDraftCartItems([]);
                        setDraftCartAttributes({});
                        setDraftCartOpen(false);
                    }}
                />
            )}
        </>
    );
}

function parseBonusProductId(raw: string): { id: string; quantity: number } {
    const trimmed = (raw || "").trim();
    const match = trimmed.match(/^(\d+)\s*[xX]\s*(.+)$/);
    if (match) {
        return { id: match[2].trim(), quantity: parseInt(match[1], 10) || 1 };
    }
    return { id: trimmed, quantity: 1 };
}

function getItemObj(id, currentAppData, defaultProps = {}, parentId?: string | number, quantity: number = 1): any {
    const newProps = {
        _seat: currentAppData.seat,
        _color: currentAppData.color,
        _bonus: "exclusive_sale",
        _year: currentAppData.year ? `${currentAppData.year}` : "",
        _make: currentAppData.make ? `${currentAppData.make}` : "",
        _model: currentAppData.model ? `${currentAppData.model}` : "",
        _trim: currentAppData.trim ? `${currentAppData.trim}` : "",
        _cab: currentAppData.cab ? `${currentAppData.cab}` : "",
        _date_add_to_cart: new Date().toISOString(),
    };
    try {
        const bodyClassList = document.body.classList;
        const accClass = Array.from(bodyClassList).find((c) =>
            c.startsWith("ACC_SCS_")
        );
        if (accClass) {
            newProps["_acc_template"] = accClass;
        }
    }
    catch (e) {
        console.error(e);
    }

    const seatCoverId = getSeatCoverId(currentAppData);
    const objb1: any = {
        quantity: quantity,
        id: id,
        properties: {...newProps, ...defaultProps},
    };
    if (!shouldIgnoreParent(id)) {
        objb1.parent_id = parentId ?? seatCoverId;
    }
    return objb1;
}
